<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_2095_13180)">
      <path
        d="M16.172 11.0007L10.808 5.63666L12.222 4.22266L20 12.0007L12.222 19.7787L10.808 18.3647L16.172 13.0007H4V11.0007H16.172Z"
        :fill="on ? '#0058AA' : '#21272A'"
      />
    </g>
    <defs>
      <clipPath id="clip0_2095_13180">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  name: 'ArrowRight',
  props: {
    on: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style scoped lang="scss"></style>
